import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  :root {
    --primary-color: #39ff14;
    --secondary-color: #2cb00f;
    --accent-color: #98ff85;
    --background-color: #0A0A0A;
    --text-color: #e2e8f0;
    --text-light: #94a3b8;
    --white: #ffffff;
    --black: #0f172a;

    /* Dark theme gray palette */
    --gray-100: #1e293b; /* A bit lighter than background */
    --gray-200: #334155;
    --gray-300: #475569;
    --gray-400: #64748b;
    --gray-500: #94a3b8;
    --gray-600: #cbd5e1;
    --gray-700: #e2e8f0;
    --gray-800: #f1f5f9;
    --gray-900: #f8fafc;
    
    --success-color: #10b981;
    --error-color: #ef4444;
    --warning-color: #f59e0b;
    --info-color: #3b82f6;
    
    --font-primary: 'VT323', monospace;
    --font-secondary: 'VT323', monospace;
    --font-heading: 'VT323', monospace;
    
    --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
    --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
    
    --border-radius-sm: 0.125rem;
    --border-radius-md: 0.375rem;
    --border-radius-lg: 0.5rem;
    --border-radius-xl: 0.75rem;
    --border-radius-2xl: 1rem;
    --border-radius-full: 9999px;
    
    --transition-fast: 150ms;
    --transition-normal: 300ms;
    --transition-slow: 500ms;
    
    --container-width: 1200px;
    --header-height: 70px;
    --footer-height: 60px;
  }
  
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
  html {
    font-size: 18px;
    scroll-behavior: smooth;
  }
  
  body {
    font-family: var(--font-primary);
    background-color: var(--background-color);
    color: var(--text-color);
    line-height: 1.5;
    overflow-x: hidden;
  }
  
  a {
    text-decoration: none;
    color: var(--primary-color);
    transition: color var(--transition-fast) ease;
    
    &:hover {
      color: var(--secondary-color);
    }
  }
  
  button {
    cursor: pointer;
    font-family: var(--font-primary);
  }
  
  ul, ol {
    list-style-position: inside;
  }
  
  img {
    max-width: 100%;
    height: auto;
  }
  
  h1, h2, h3, h4, h5, h6 {
    font-family: var(--font-heading);
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: 1rem;
  }
  
  h1 {
    font-size: 2.5rem;
  }
  
  h2 {
    font-size: 2rem;
  }
  
  h3 {
    font-size: 1.75rem;
  }
  
  h4 {
    font-size: 1.5rem;
  }
  
  h5 {
    font-size: 1.25rem;
  }
  
  h6 {
    font-size: 1rem;
  }
  
  p {
    margin-bottom: 1rem;
  }
  
  section {
    padding: 4rem 0;
  }
  
  .container {
    width: 100%;
    max-width: var(--container-width);
    margin: 0 auto;
    padding: 0 1rem;
  }
  
  .section-title {
    text-align: center;
    margin-bottom: 3rem;
    
    h2 {
      position: relative;
      display: inline-block;
      
      &:after {
        content: '';
        position: absolute;
        bottom: -10px;
        left: 50%;
        transform: translateX(-50%);
        width: 50px;
        height: 3px;
        background-color: var(--primary-color);
      }
    }
  }
  
  @media (max-width: 768px) {
    html {
      font-size: 14px;
    }
    
    section {
      padding: 3rem 0;
    }
  }
  
  @media (max-width: 480px) {
    html {
      font-size: 12px;
    }
    
    section {
      padding: 2rem 0;
    }
  }
`;

export default GlobalStyles;